import { People } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { alertError } from "../../utils/logger";

export function DashboardPage() {
	const [data, setData] = useState([]);
	const history = useHistory();

	useEffect(() => {
		async function fetchData() {
			try {
				setData({
					numAdmins: 0,
				});
			} catch (err) {
				alertError({
					error: err,
					customMessage: "Could not get statistics.",
				});
			}
		}
		fetchData();
	}, []);

	return (
		<>
			<div className="row justify-content-center">
				<div
					className="col-12 col-md-4 text-center my-2"
					role="button"
					onClick={() => history.push("/usuarios")}
				>
					<div className="card">
						<div className="card-body">
							<h5 className="card-title">
								<People /> Usuarios
							</h5>
							<div className="contentDash"></div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
